import React from 'react';
import LandingPageTemplate from '../../components/LandingPageTemplate';
import {
  Speed as SpeedIcon,
  Security as SecurityIcon,
  CloudQueue as CloudIcon,
  TrendingUp as TrendingUpIcon,
} from '@mui/icons-material';
import heroImage from '../../assets/images/hpe_servers/HPE_Superdome_Flex_Server.png';

const VMwareLanding: React.FC = () => {
  return (
    <LandingPageTemplate
      headline="Transform Your Infrastructure with VMware vSphere"
      subheadline="Enterprise virtualization that reduces costs by 70% while improving performance and reliability."
      heroImage={heroImage}
      ctaText="Get a Quote"
      valueProps={[
        'Reduce Hardware Costs',
        'Improve Resource Utilization',
        'Faster Deployment',
        'Enhanced Disaster Recovery',
        'Simplified Management',
        'Proven Enterprise Solution',
      ]}
      features={[
        {
          title: 'VMware vSphere Virtualization',
          description:
            'Industry-leading hypervisor technology that powers over 500,000 organizations worldwide. Consolidate your physical servers and maximize resource efficiency.',
          icon: <SpeedIcon />,
        },
        {
          title: 'vCenter Management Platform',
          description:
            'Centralized management for your entire virtual infrastructure. Monitor, automate, and control all your virtual machines from a single pane of glass.',
          icon: <CloudIcon />,
        },
        {
          title: 'High Availability & Fault Tolerance',
          description:
            'Ensure business continuity with automated failover and zero-downtime maintenance. Your critical applications stay running even during hardware failures.',
          icon: <SecurityIcon />,
        },
        {
          title: 'vMotion Live Migration',
          description:
            'Move running virtual machines between servers with zero downtime. Perform maintenance without disrupting your users or applications.',
          icon: <TrendingUpIcon />,
        },
      ]}
      stats={[
        { value: '70%', label: 'Cost Reduction' },
        { value: '500K+', label: 'Organizations' },
        { value: '99.999%*', label: 'Uptime' },
        { value: '10X', label: 'ROI Average' },
      ]}
      ctaHeadline="Ready to Deploy VMware vSphere?"
      ctaDescription="Get a free assessment and customized proposal from TNCOSOFT's certified VMware experts."
      primaryColor="#0091DA"
      accentColor="#005E8A"
    />
  );
};

export default VMwareLanding;
